import styled from 'styled-components';
import { THEME } from '../../../../themes';
import { HeadlineFont, Title1Font, Title2Font } from '../../../../themes/fonts';
import { fadeInAnimation } from '../../../../animations';
import { ELEMENTS_DURATION } from '../../../../consts/durations';
import {
  PAGE_CONTENT_DELAY,
  PAGE_CONTENT_DELAY_WITH_WELCOME_DELAY,
  PAGE_TITLE_DELAY,
} from '../../../../consts/delays';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 80vw;
  min-width: 960px;
  padding: 0 ${THEME.SPACING.GRAND};
  box-sizing: content-box;
  flex-wrap: wrap;
  margin: 5vh auto ${THEME.SPACING.MEDIUM};
`;
export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.BASE};
`;

export const BodyContainer = styled.div<{
  includeWelcomeScreenDelay?: boolean
  marginTop?: string
  marginBottom?: string
}>`
  ${Title2Font};
  color: ${THEME.COLORS.PRIMARY_DARK};
  width: 100%;
  opacity: 0;
  z-index: 10;
  margin-top: ${THEME.SPACING.LARGE};
  animation: ${({ includeWelcomeScreenDelay }) => fadeInAnimation({
    animationDuration: ELEMENTS_DURATION.PAGE_TITLE_DURATION,
    animationDelay: includeWelcomeScreenDelay ?
      PAGE_CONTENT_DELAY_WITH_WELCOME_DELAY :
      PAGE_CONTENT_DELAY,
  })
};
  @media (max-height: ${THEME.BREAKPOINTS.HEIGHT.SMALL}px) {
    margin-top: ${THEME.SPACING.BASE};
  }
`;

export const PositionInfo = styled.span`
  ${HeadlineFont};
  font-weight: normal;
  opacity: ${THEME.OPACITY.MED};
  color: ${THEME.COLORS.PRIMARY_DARK};
  
  strong {
    font-weight: 500;
  }
`;

export const PageTitle = styled.span<{
  includeAnimationDelay?: boolean,
  maxWidth?: number,
}>`
  ${Title1Font};
  font-weight: 300;
  color: ${THEME.COLORS.CONTENT_A};
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '680px')};
  animation: ${({ includeAnimationDelay }) => {
    return fadeInAnimation({
      animationDuration: ELEMENTS_DURATION.PAGE_TITLE_DURATION,
      animationDelay: includeAnimationDelay ? PAGE_TITLE_DELAY : 0,
    });
  }
};
  @media (max-height: ${THEME.BREAKPOINTS.HEIGHT.SMALL}px) {
    ${Title2Font};
  }
`;

export const PageTitleBold = styled.span`
  ${Title1Font};
  font-weight: 600;
  color: ${THEME.COLORS.PRIMARY_DARK};
  @media (max-height: ${THEME.BREAKPOINTS.HEIGHT.SMALL}px) {
    ${Title2Font};
    font-weight: 600;
  }
`;
